import BaseService from './base'

export default class CurrencyService extends BaseService {
  static resource() {
    return 'api/v1/external/currencies'
  }
}
